import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats a number with the specified number of decimal places
 */
export function formatNumber(value: number, decimals: number = 2): string {
  return value.toFixed(decimals)
}

/**
 * Unescapes Markdown syntax characters in LaTeX expressions
 * Removes backslashes before common characters that might be escaped by Google Docs
 */
export function unescapeMarkdownForLaTeX(text: string): string {
  // Characters to unescape: =_*{}[]<>()#+-.!|` and \ itself
  return text.replace(/\\([=_*{}[\]<>()+\-#.!|`\\])/g, '$1');
}

